<accordion [isAnimated]="true" class="mt-4" [attr.data-section-id]="valueInDispute.id">
  <accordion-group #Group [isOpen]="isOpen || first" (isOpenChange)="onAccordionToggle($event)">
    <button
      class="btn btn-link text-decoration-none btn-block justify-content-between d-flex w-100 shadow-none fs-5"
      accordion-heading type="button">
      <div class="d-flex w-100 align-items-center">
        <div class="flex-grow-1 d-flex align-items-center">
          <i class="fa-solid pe-3" [ngClass]="{
          'text-success': isValid$ | async,
          'text-warning': !(isValid$ | async),
          'fa-triangle-exclamation': !(isValid$ | async),
          'fa-circle-check': isValid$ | async
          }"></i>
          <span class="text-start" [ngClass]="{
           'text-success': isValid$ | async,
           'text-warning': !(isValid$ | async)
          }">
            <ng-container *ngIf="title && title.length > 0; else fallbackTitle">
              {{ title }} {{ index + 1 }}
            </ng-container>
            <ng-template #fallbackTitle>
              {{ 'General.StepValuesInDispute' | translate }} {{ index + 1 }}
              <ng-container *ngIf="selectedProductName">
                - {{ selectedProductName }}
              </ng-container>
            </ng-template>
          </span>
        </div>
        <div class="icons d-flex align-items-center justify-content-end text-end" style="width: 60px;">
          <i class="fa-solid pe-3"
             [ngClass]="{'fa-chevron-down': !Group.isOpen, 'fa-chevron-up': Group.isOpen}"></i>
          <i class="fa-solid fa-trash text-warning"
             *ngIf="!first && !hideDeleteIcon"
             (click)="removeDisputeinValue($event)"></i>
        </div>
      </div>
    </button>

    <div class="p-2">
      <form [formGroup]="dynamicForm">
        <ng-container *ngIf="enableMultipleProductsSelection">
          <app-form-input-dropdown
            [label]="'StepValueInDispute.Product' | translate"
            [values]="productSelection"
            [formName]="dynamicForm"
            [control]="getFormControlSafe('Product')"
            [name]="'Product_' + valueInDispute.id"
            [dynamicFormSettings]="true"
            [placeholder]="'General.InputSelectPlaceholder' | translate">
          </app-form-input-dropdown>

          <!-- Dynamic Fields Section -->
          <div *ngIf="selectedProductFields?.SelectedFields?.length > 0" [ngClass]="'product-' + selectedProductName" [attr.data-product-key]="getProductSelectionKey()">
            <div *ngFor="let field of selectedProductFields.SelectedFields; trackBy: trackByField">
              <!-- Lookup and Optionset fields -->
              <ng-container *ngIf="field.Type === 'lookup' || field.Type === 'optionset'">
                <app-form-input-dropdown
                  [label]="field.SpaLabel"
                  [values]="field.Options"
                  [formName]="dynamicForm"
                  [control]="getFormControlSafe(field.FieldName)"
                  [name]="field.Name"
                  [dynamicFormSettings]="true"
                  [placeholder]="'General.InputSelectPlaceholder' | translate"
                ></app-form-input-dropdown>
              </ng-container>

              <!-- Text fields (including email, tel, url) -->
              <ng-container *ngIf="field.Type === 'text' || field.Type === 'email' || field.Type === 'tel' || field.Type === 'url'">
                <app-form-input-text
                  [type]="field.Type"
                  [placeholder]="field.SpaLabel"
                  [required]="field.Required"
                  [name]="field.Name"
                  [label]="field.SpaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControlSafe(field.FieldName)"
                  [maxLength]="field.MaxLength"
                ></app-form-input-text>
              </ng-container>

              <!-- Currency fields -->
              <ng-container *ngIf="field.Type === 'currency'">
                <app-form-input-currency
                  [label]="field.SpaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControlSafe(field.FieldName)"
                  [name]="field.Name"
                  [required]="field.Required"
                  [min]="field.Min"
                  [max]="field.Max"
                  [currency]="field.Currency"
                  [readonly]="field.readonly"
                ></app-form-input-currency>
              </ng-container>

              <!-- Boolean fields -->
              <ng-container *ngIf="field.Type === 'boolean'">
                <app-form-input-dropdown
                  [label]="field.SpaLabel"
                  [values]="field.Options"
                  [formName]="dynamicForm"
                  [control]="getFormControlSafe(field.FieldName)"
                  [name]="field.Name"
                  [dynamicFormSettings]="true"
                  [placeholder]="'General.InputSelectPlaceholder' | translate"
                  [required]="field.Required"
                  [readonly]="field.readonly"
                ></app-form-input-dropdown>
              </ng-container>

              <!-- Date fields -->
              <ng-container *ngIf="field.Type === 'date'">
                <!-- Initial state - no date entered or untouched -->
                <ng-container *ngIf="!isDateValid(field.FieldName) && !isDateInvalid(field.FieldName)">
                  <app-form-input-date
                    [label]="field.SpaLabel"
                    [formName]="dynamicForm"
                    [control]="getFormControlSafe(field.FieldName)"
                    [name]="field.Name"
                    [required]="field.Required"
                  ></app-form-input-date>
                </ng-container>

                <!-- Invalid state -->
                <ng-container *ngIf="isDateInvalid(field.FieldName)">
                  <app-form-input-date
                    [label]="field.SpaLabel"
                    [formName]="dynamicForm"
                    [control]="getFormControlSafe(field.FieldName)"
                    [name]="field.Name"
                    [required]="field.Required"
                  ></app-form-input-date>
                </ng-container>

                <!-- Valid state - only show when touched -->
                <ng-container *ngIf="isDateValid(field.FieldName)">
                  <app-form-input-date
                    [label]="field.SpaLabel"
                    [formName]="dynamicForm"
                    [control]="getFormControlSafe(field.FieldName)"
                    [name]="field.Name"
                    [required]="field.Required"
                  ></app-form-input-date>
                </ng-container>
              </ng-container>
            </div>

            <!-- File upload section -->
            <div class="mt-3" *ngIf="projectSettings?.streitwertRequiredFileCategories?.length > 0">
              <div class="mt-3" *ngFor="let category of projectSettings.streitwertRequiredFileCategories; trackBy: trackByFileCategory">
                <b>{{ category.title || ('General.UploadTitle' | translate) }}</b>
                <app-form-input-file
                  [formName]="dynamicForm"
                  [name]="'Files_' + category.id + '_' + valueInDispute.id"
                  [minFiles]="category.minimumFiles"
                  [control]="getFileFormControlSafe(category.id)"
                  [projectShortName]="projectShortName"
                  [tokenIdentifier]="tokenIdentifier"
                  [sessionId]="sessionToken"
                  [valueInDispute]="true"
                  [projectSettings]="projectSettings"
                  [fileCategory]="category.id"
                  [index]="index"
                  [isClaimFile]="true"
                  [isDatagateMode]="isDatagateMode"
                  [disableFileGet]="disableFileGet"
                  (disputeBoxValid)="onFileValidationChange($event, category.id)"
                  (fileUploaded)="onFileUpload($any($event))"
                  (progressChanged)="onProgressChanged()"
                >
                </app-form-input-file>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="!enableMultipleProductsSelection">
          <div *ngFor="let field of fields.SelectedFields; trackBy: trackByField">
            <!-- Lookup and Optionset fields -->
            <ng-container *ngIf="field.Type === 'lookup' || field.Type === 'optionset'">
              <app-form-input-dropdown
                [label]="field.SpaLabel"
                [values]="field.Options"
                [formName]="dynamicForm"
                [control]="getFormControlSafe(field.FieldName)"
                [name]="field.Name"
                [dynamicFormSettings]="true"
                [placeholder]="'General.InputSelectPlaceholder' | translate"
                [readonly]="field.readonly"
              ></app-form-input-dropdown>
            </ng-container>

                          <!-- Text fields -->
              <ng-container *ngIf="field.Type === 'text'">
                <app-form-input-text
                  [type]="field.Type"
                  [placeholder]="field.SpaLabel"
                  [required]="field.Required"
                  [name]="field.Name"
                  [label]="field.SpaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControlSafe(field.FieldName)"
                  [maxLength]="field.MaxLength"
                  [readonly]="field.readonly"
                ></app-form-input-text>
              </ng-container>

            <!-- Currency fields -->
            <ng-container *ngIf="field.Type === 'currency'">
              <app-form-input-currency
                [label]="field.SpaLabel"
                [formName]="dynamicForm"
                [control]="getFormControlSafe(field.FieldName)"
                [name]="field.Name"
                [required]="field.Required"
                [min]="field.Min"
                [max]="field.Max"
                [currency]="field.Currency"
                [readonly]="field.readonly"
              ></app-form-input-currency>
            </ng-container>

            <!-- Boolean fields -->
            <ng-container *ngIf="field.Type === 'boolean'">
              <app-form-input-dropdown
                [label]="field.SpaLabel"
                [values]="field.Options"
                [formName]="dynamicForm"
                [control]="getFormControlSafe(field.FieldName)"
                [name]="field.Name"
                [dynamicFormSettings]="true"
                [placeholder]="'General.InputSelectPlaceholder' | translate"
                [required]="field.Required"
                [readonly]="field.readonly"
              ></app-form-input-dropdown>
            </ng-container>

            <!-- Date fields -->
            <ng-container *ngIf="field.Type === 'date'">
              <!-- Initial state - no date entered or untouched -->
              <ng-container *ngIf="!isDateValid(field.FieldName) && !isDateInvalid(field.FieldName)">
                <app-form-input-date
                  [label]="field.SpaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControlSafe(field.FieldName)"
                  [name]="field.Name"
                  [required]="field.Required"
                ></app-form-input-date>
              </ng-container>

              <!-- Invalid state -->
              <ng-container *ngIf="isDateInvalid(field.FieldName)">
                <div class="alert alert-danger">
                  {{ 'General.InvalidDate' | translate }}
                </div>
                <app-form-input-date
                  [label]="field.SpaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControlSafe(field.FieldName)"
                  [name]="field.Name"
                  [required]="field.Required"
                ></app-form-input-date>
              </ng-container>

              <!-- Valid state - only show when touched -->
              <ng-container *ngIf="isDateValid(field.FieldName)">
                <app-form-input-date
                  [label]="field.SpaLabel"
                  [formName]="dynamicForm"
                  [control]="getFormControlSafe(field.FieldName)"
                  [name]="field.Name"
                  [required]="field.Required"
                ></app-form-input-date>
              </ng-container>
            </ng-container>
          </div>

          <!-- File upload section -->
          <div class="mt-3" *ngIf="projectSettings?.streitwertRequiredFileCategories?.length > 0">
            <div class="mt-3" *ngFor="let category of projectSettings.streitwertRequiredFileCategories; trackBy: trackByFileCategory">
              <b>{{ category.title || ('General.UploadTitle' | translate) }}</b>
              <app-form-input-file
                [formName]="dynamicForm"
                [name]="'Files_' + category.id + '_' + valueInDispute.id"
                [minFiles]="category.minimumFiles"
                [control]="getFileFormControlSafe(category.id)"
                [projectShortName]="projectShortName"
                [tokenIdentifier]="tokenIdentifier"
                [sessionId]="sessionToken"
                [valueInDispute]="true"
                [projectSettings]="projectSettings"
                [fileCategory]="category.id"
                [index]="index"
                [isClaimFile]="true"
                [isDatagateMode]="isDatagateMode"
                [disableFileGet]="disableFileGet"
                (disputeBoxValid)="onFileValidationChange($event, category.id)"
                (fileUploaded)="onFileUpload($any($event))"
                (progressChanged)="onProgressChanged()"
              >
              </app-form-input-file>
            </div>
          </div>
        </ng-container>

        <div class="mt-3" *ngIf="isValid$ | async">
          <button type="button" class="btn btn-primary" (click)="onOkAndClose()">
            OK & schließen
          </button>
        </div>
      </form>
    </div>
  </accordion-group>
</accordion>
